import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import CustomCursor from "@/components/CustomCursor";

const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const Manufacturing = lazy(() => import("@/pages/Manufacturing"));
const Products = lazy(() => import("@/pages/Products"));
const Customization = lazy(() => import("@/pages/Customization"));
const Quality = lazy(() => import("@/pages/Quality"));
const Markets = lazy(() => import("@/pages/Markets"));
const Gallery = lazy(() => import("@/pages/Gallery"));
const Faq = lazy(() => import("@/pages/Faq"));
const Contact = lazy(() => import("@/pages/Contact"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Sitemap = lazy(() => import("@/pages/Sitemap"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}

function PageShell({ children }) {
  return (
    <div className="page-shell" data-testid="page-shell">
      {children}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <main id="main" data-testid="main-content">
        <Suspense fallback={<div className="page-fallback">Loading…</div>}>
          <Routes>
            <Route path="/" element={<PageShell><Home /></PageShell>} />
            <Route path="/about" element={<PageShell><About /></PageShell>} />
            <Route path="/manufacturing" element={<PageShell><Manufacturing /></PageShell>} />
            <Route path="/products" element={<PageShell><Products /></PageShell>} />
            <Route path="/customization" element={<PageShell><Customization /></PageShell>} />
            <Route path="/quality" element={<PageShell><Quality /></PageShell>} />
            <Route path="/markets" element={<PageShell><Markets /></PageShell>} />
            <Route path="/gallery" element={<PageShell><Gallery /></PageShell>} />
            <Route path="/faq" element={<PageShell><Faq /></PageShell>} />
            <Route path="/contact" element={<PageShell><Contact /></PageShell>} />
            <Route path="/privacy" element={<PageShell><Privacy /></PageShell>} />
            <Route path="/terms" element={<PageShell><Terms /></PageShell>} />
            <Route path="/sitemap" element={<PageShell><Sitemap /></PageShell>} />
            <Route path="*" element={<PageShell><Home /></PageShell>} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <FloatingContact />
      <CustomCursor />
    </BrowserRouter>
  );
}
